export default __webpack_public_path__ + "static/media/articles-previous-icon.a71f8d54.svg";